import React, {useState} from 'react';
import {Button, Col, Modal, Row} from "react-bootstrap";
import {Link} from "react-router";

export const EmailVerificationModal = ({
                                           show,
                                           closeModal,
                                           verificationEmailWasSend,
                                           verifySender,
                                           resendVerifyEmail,
                                           emailToVerify,
                                           closeEmailDialog
                                       }) => {

    const [errorMessage, setErrorMessage] = useState('')
    const [message, setMessage] = useState('')
    const [emailSend, setEmailSend] = useState(false)

    const handleVerify = (e) => {
        e.preventDefault()
        verifySender({email: emailToVerify}, res => {
            if (res.error) {
                setErrorMessage(res.error)
                setMessage('')
            } else {
                if (res.verified) {
                    setMessage('Your email is verified')
                    setErrorMessage('')
                    setEmailSend(true)
                } else {
                    setMessage('Please, confirm verification on your mailbox')
                    setErrorMessage('')
                    setEmailSend(true)
                }
            }
        })
    }

    return (
        <Modal
            animation={false}
            show={show}
            onHide={closeModal}
            className={"heightAuto maxHeight90 emailVerificationModal fontIOS"}
            backdrop="static"
            bsSize="xs"
        >
            <Modal.Header>
                <Modal.Title>Verify Sender <b>{emailToVerify}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={verificationEmailWasSend ? 12 : 6}>
                        <h4>Important information</h4>
                        {verificationEmailWasSend ?
                            <p>Please check your mailbox and follow the verification instruction or resend verification
                                email by clicking <strong>Resend</strong> button.</p> :
                            <>
                                <p>If the email address is not verified, your email will be sent from a default Treehub
                                    email.
                                    If you want to use your own email address: </p>
                                <ol>
                                    <li>Click "Verify"</li>
                                    <li>Check your inbox for the verification email</li>
                                    <li>Open the message and click the verification link</li>
                                </ol>
                                <p>If you want to verify a <b>domain</b>, click <Link to="/email_domains"
                                                                                    onClick={()=> {
                                                                                        closeModal()
                                                                                        closeEmailDialog()
                                                                                    }}>here</Link></p>
                            </>
                        }
                    </Col>
                    <Col md={verificationEmailWasSend ? 12 : 6}>
                        {errorMessage && <p className="text-danger">{errorMessage}</p>}
                        {message && <p className="text-success">{message}</p>}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" onClick={closeModal}
                        data-dismiss="modal" bsStyle="primary" bsSize="small">Close
                </Button>

                {verificationEmailWasSend ? <Button
                        bsSize="small"
                        disabled={emailSend}
                        onClick={() => resendVerifyEmail({email: emailToVerify}, res => {
                            if (res.error) {
                                setErrorMessage(res.error)
                                setMessage('')
                            } else {
                                setMessage('Please, confirm verification on your mailbox')
                                setErrorMessage('')
                                setEmailSend(true)
                            }
                        })}>Resend</Button> :
                    <Button bsStyle='success' disabled={emailSend} type="submit" bsSize="small"
                            onClick={handleVerify}>Verify</Button>}
            </Modal.Footer>
        </Modal>
    )
}
